<template>
    <div>
        <header class="pb-3">
            <b-container>
                <b-row>
                    <b-col>
                        <router-link to="/"><img src="@/assets/thepaymentoption-logo-white.svg" class="logo mt-4"/></router-link>
                    </b-col>
                    <b-col class="text-right pt-5">

                    </b-col>
                </b-row>
            </b-container>
        </header>

        <b-container class="pt-5 mt-4 pb-5" v-if="!approved && !declined">
            <h5><i class="far fa-spinner-third fa-spin mr-3"></i>Processing request... please wait.</h5>
        </b-container>

        <b-container class="pt-5 mt-4 pb-5" v-if="approved">
            <h4><i class="far fa-check mr-3 text-success"></i>Great! We've fulfilled your request!</h4>
            <div class="text-muted">You may close this window or tab.</div>
        </b-container>

        <b-container class="pt-5 mt-4 pb-5" v-if="declined">
            <h4><i class="far fa-ban mr-3 text-danger"></i>Oh-no! We were unable to complete your request!</h4>
            <div class="text-muted">Unfortunately, there isn't much more we can tell you at this point.<br>Please check your original request and try or <a href="mailto:help@thepaymentoption.com">contact us</a> or your merchant for help.</div>
        </b-container>`

        <footer class="pt-3 pb-2">
            <b-container>
                <copyright class="dark mt-3 mb-3"/>
            </b-container>
        </footer>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import axios from "axios";
    import {apiUrl} from "@/constants/config";

    export default {
        name: "ApprovePayment",
        components: {Copyright},
        props: ['code'],
        data: function() {
            return {
                approved: false,
                declined: false
            }
        },
        methods: {
            submit: function() {
                axios.post(apiUrl + 'api/account/approve_p', {secret: this.code}).then(response => {
                    this.approved = true;
                }, err => {
                    if (err.response.status === 404) {
                        // Already completed
                        this.approved = true;
                    } else {
                        this.declined = true;
                    }
                });
            }
        },
        mounted() {
            this.submit();
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    header {
        .logo {
            max-width: 160px;
        }

        background: #3c3c5f;
        color: white;
    }

    footer {
        border-top: 1px solid $gray-300;
        padding: 2rem 0 0;
        margin-top: 2rem;

        .copyright {
            color: $gray-500 !important;
        }
    }
</style>
